<template>
    <gridComponent :loader="loader" :items="items" :itemsData="itemsData" :headers="headers"
        :ColonneWidth="columnWidths" :GetFunction="getProductsList" :openNewWindow="'productEdit'">
        <template v-slot:Filter0>
            <ColumnFilter :title="$t('products.name')" :Filter="filters.SearchNom" :getList="applyFilter"
                @cancel="clearFilter('SearchNom')">
                <template v-slot:input>
                    <v-text-field v-model="filters.SearchNom" variant="outlined" maxlength="33" hide-details />
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:Filter1>
            <ColumnFilter :title="$t('products.category')" :Filter="filters.CategoryName" :getList="applyFilter"
                @cancel="clearFilter('CategoryName')">
                <template v-slot:input>
                    <v-text-field v-model="filters.CategoryName" variant="outlined" maxlength="33" hide-details />
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:Filter2>
            <ColumnFilter :title="$t('products.mark')" :Filter="filters.SearchMarque" :getList="applyFilter"
                @cancel="clearFilter('SearchMarque')">
                <template v-slot:input>
                    <v-text-field v-model="filters.SearchMarque" variant="outlined" maxlength="33" hide-details />
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:Filter3>
            <ColumnFilter :title="$t('products.supplier')" :Filter="filters.supplier" :getList="applyFilter"
                @cancel="clearFilter('supplier')">
                <template v-slot:input>
                    <v-text-field v-model="filters.supplier" variant="outlined" maxlength="33" hide-details />
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:Filter4>
            <ColumnFilter :title="$t('products.price')" :Filter="filters.price" :getList="applyFilter"
                @cancel="clearFilter('price')">
                <template v-slot:input>
                    <v-text-field v-model="filters.price" variant="outlined" type="number" hide-details />
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:Filter5>
            <ColumnFilter :title="$t('products.status')" :Filter="filters.isActive" :getList="applyFilter"
                @cancel="clearFilter('isActive')">
                <template v-slot:input>
                    <v-radio-group v-model="filters.isActive" class="d-flex flex-row">
                        <v-radio :label="$t('common.active')" value="1" class="mr-4" />
                        <v-radio :label="$t('common.inactive')" value="0" class="mr-4" />

                    </v-radio-group>
                </template>
            </ColumnFilter>
        </template>
        <template v-slot:item0="{ item }">
            <media-card :Logo="item.images?.length > 0 ? item.images[0] : null" :Name="item.name" :width="'250px'" />
        </template>
        <template v-slot:item1="{ item }">
            <div class="categories-list">
                {{item.categories?.map(cat => cat.name).join(', ') || '-'}}
            </div>
        </template>
        <template v-slot:item2="{ item }">
            {{ item.marque }}
        </template>
        <template v-slot:item3="{ item }">
            {{ item.supplier?.name || '-' }}
        </template>
        <template v-slot:item4="{ item }">
            {{ formatPrice(item.basePrice) }} 
            <!-- <br/> {{ finalePrice(item) }} -->
        </template>
        <template v-slot:item5="{ item }">
            <StatusButton :title="statut(item)" :color="getStatusColor(item.isActif)" />
        </template>
        <template v-slot:edit="{ item, index }">
            <products-actions :Id="index" :productId="item.id" :GetProductsAfterDeleted="getProductsList"
                :productStatus="item.isActif" />
        </template>
    </gridComponent>
</template>

<script>
import { defineComponent } from 'vue'
import gridComponent from '@/genericComponent/gridComponent.vue'
import ColumnFilter from "@/genericComponent/ColumnFilter.vue"
import ProductsActions from "@/components/products/ProductsActions.vue"
import { formatPrice, getProducts } from "@/api"
import StatusButton from "@/genericComponent/StatusButton.vue";
import mediaCard from "@/genericComponent/mediaCard.vue";
export default defineComponent({
    name: 'ProductsList',
    props: {
        productsList: {
            type: Array,
            required: true
        }
    },
    components: {
        gridComponent,
        ColumnFilter,
        ProductsActions,
        StatusButton,
        mediaCard
    },
    data() {
        return {
            products: this.productsList,
            loader: true,
            items: [],
            itemsData: null,
            page: 1,
            PageSize: 10,
            filters: {
                SearchNom: null,
                CategoryName: null,
                price: null,
                isActive: null,
                SearchMarque: null,
                supplier: null,
                search: null,
            },
            SortedBy: null,
            SortingType: null,
            columnWidths: ['20%', '20%', '15%', '20%', '15%', '10%'], // Adjusted column widths
            filterParams: null,
        }
    },
    watch: {
        filters: {
            handler() {
                this.applyFilter()
            },
            immediate: true,
            deep: true
        },
        productsList: {
            handler(newVal) {
                this.products = newVal;
                this.updateProductsList({ items: newVal });
            },
            immediate: true
        }
    },
    computed: {
        headers() {
            return [
                this.$t('products.name'),
                this.$t('products.categories'),
                this.$t('products.mark'),
                this.$t('products.supplier'),
                this.$t('products.price'),
                this.$t('products.status'),
            ]
        },
        statut() {
            return (item) => {
                switch (item.isActif) {
                    case 0: return this.$t('common.Draft');
                    case 1: return this.$t('common.ToBeValidated');
                    case 2: return this.$t('common.ToBeRectified');
                    case 3: return this.$t('common.ToBeValidatedBySupplier');
                    case 4: return this.$t('common.ValidatedBySupplier');
                    case 5: return this.$t('common.Validated');
                    case 6: return this.$t('common.active');
                    case 7: return this.$t('common.inactive');
                    case 8: return this.$t('common.Refused');
                }
            };
        },
    },
    mounted() {
        this.setupEventListeners()
        this.emitter.off('event-test')
        this.emitter.emit('remise-search-at-null');
        this.emitter.on('event-test', (event) => {
            this.filters.search = event;
        })
    },
    unmounted() {
        this.cleanupEventListeners()
        this.emitter.off('event-test')
        this.emitter.emit('remise-search-at-null');
    },
    methods: {
        applyFilter() {
            const params = new FormData();
            if (this.filters.CategoryName) params.CategoryName = this.filters.CategoryName;
            if (this.filters.SearchNom) params.SearchNom = this.filters.SearchNom;
            if (this.filters.SearchMarque) params.SearchMarque = this.filters.SearchMarque;

            if (this.filters.isActive == 1) params.isActive = 6;
            if (this.filters.availability == false || this.filters.availability == true) params.availability = this.filters.availability;
            if (this.filters.creationDate) params.CreationDate = this.filters.creationDate?.length ? this.filters.creationDate : null;
            if (this.filters.minPrice) params.minPrice = this.filters.minPrice;
            if (this.filters.maxPrice) params.maxPrice = this.filters.maxPrice;
            if (this.filters.search) params.searchTerm = this.filters.search;
            this.filterParams = params;
            this.getProductsList(1, params)
        },
        async getProductsList(page = null, FilterParams = this.filterParams) {
            FilterParams = this.filterParams;
            try {
                this.loader = true
                if (page) {
                    this.page = page
                }

                const response = await getProducts(
                    this.page,
                    this.PageSize,
                    FilterParams,
                    this.SortedBy,
                    this.SortingType
                )

                this.updateProductsList(response.data)
            } catch (error) {
                console.error('Error fetching products:', error)
            } finally {
                this.loader = false
            }
        },
        getStatusColor(status) {
            switch (status) {
                case 0: return "#BEBEBE";
                case 1: return "#FF8934";
                case 2: return "#FFDF00";
                case 3: return "#FF8934";
                case 4: return "#00CBA0";
                case 5: return "#00CBA0";
            }
        },
        updateProductsList(data) {
            this.items = data.items
            this.itemsData = {
                numberOfPage: data.totalPages,
                totalItemsCount: data.totalCount,
                pageNumber: data.pageNumber,
                hasPreviousPage: data.hasPreviousPage,
                hasNextPage: data.hasNextPage
            }
        },
        clearFilter(filterName) {
            this.filters[filterName] = null
            this.getProductsList(1)
        },
        formatPrice(price) {
            return formatPrice(price)
        },
        setupEventListeners() {
            this.emitter.off('event-test')
            this.emitter.on('event-test', this.handleSearchEvent)
            this.emitter.emit('remise-search-at-null')
        },
        cleanupEventListeners() {
            this.emitter.off('event-test')
            this.emitter.emit('remise-search-at-null')
        },

        handleSearchEvent(searchTerm) {
            this.filters.SearchNom = searchTerm
            this.applyFilter()
        },
        updateFilter(filters) {
            this.filters = filters;
        },
        finalePrice(item) {
            const variant = item.variants[0];
            const prices = variant.priceByVariant != [] ? variant.priceByVariant[0].pricePerQuantity : [];
            const stock = variant.stock || 10000;
            const ranges = [];

            for (let i = 0; i < prices.length; i++) {
                const current = prices[i];
                const next = prices[i + 1];
                const start = current.quantity;
                const end = next ? next.quantity - 1 : stock;
                const price = current.finalPriceTTC;

                ranges.push(`${start}-${end}: ${price} $`);
            }

            return ranges.join(' , ');
        }
    }
})
</script>

<style scoped>
.categories-list {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
